export const createLookupHash = (collection, lookupKey) =>
  collection.reduce((acc, item) => {
    return {
      ...acc,
      [item[lookupKey]]: item,
    };
  }, {});
